
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/hooks/useAuth';
import { User, Building, Briefcase, Mail } from 'lucide-react';

interface ProfileViewProps {
  onEdit: () => void;
}

export const ProfileView = ({ onEdit }: ProfileViewProps) => {
  const { profile } = useAuth();

  if (!profile) {
    return (
      <Card>
        <CardContent className="p-6">
          <p className="text-center text-gray-500">Chargement du profil...</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <User className="h-5 w-5" />
          Mon Profil
        </CardTitle>
        <CardDescription>
          Vos informations personnelles et professionnelles
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700">Prénom</label>
            <p className="text-gray-900">{profile.first_name}</p>
          </div>
          
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700">Nom</label>
            <p className="text-gray-900">{profile.last_name}</p>
          </div>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
            <Mail className="h-4 w-4" />
            Email
          </label>
          <p className="text-gray-900">{profile.email}</p>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
            <Building className="h-4 w-4" />
            Entreprise
          </label>
          <p className="text-gray-900">{profile.company}</p>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
            <Briefcase className="h-4 w-4" />
            Poste
          </label>
          <p className="text-gray-900">{profile.position}</p>
        </div>

        <div className="pt-4">
          <Button onClick={onEdit} className="w-full">
            Modifier le profil
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
